import { createModule } from '../../createModule';
export const createRFQAPI = createModule(({ http }) => {
    return {
        getRFQData: async () => {
            const res = await http.get('/v2/rfq/');
            return res;
        },
        getRFQVol: async () => {
            const res = await http.get('/v2/rfq/vol');
            return res;
        },
        getRFQInterestRate: async () => {
            const res = await http.get('/v2/rfq/interest_rate');
            return res;
        },
        getPricingMatrix: async () => {
            const res = await http.get('/v2/rfq/pricing_matrix');
            return res;
        },
    };
});
